import i18n from "../i18n";

export function getLocale() {
  const locale = i18n.language;
  return locale;
}
